import dayjs, { Dayjs } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export function dateFromNow(date: string | Date | Dayjs | null | undefined) {
  if (!date) {
    return "";
  }

  const parsedDate = dayjs(date);

  if (!parsedDate.isValid()) {
    return "";
  }

  return parsedDate.fromNow();
}
